import { useState } from "react";

import { Button, ModalDelete } from "expano-components";

import { Main, PageLoader, Error, CampaignStatsChart } from "components";
import useGet from "hooks/useGet";
import useDelete from "hooks/useDelete";

import { ReactComponent as ProductIcon } from "icons/product.svg";

import BasicData from "./components/BasicData";
import ChannelCampaignGroups from "./components/ChannelCampaignGroups";

const ChannelCampaignEdit = ({
  match: {
    params: { channel_id, channel_campaign_id },
  },
  history,
}) => {
  const [show_delete_modal, setShowDeleteModal] = useState(false);

  const {
    is_loading,
    is_error,
    error,
    data: channel_campaign,
    refetch,
  } = useGet({
    query: ["channel_campaigns", channel_campaign_id],
    path: `/channels/${channel_id}/channel_campaigns/${channel_campaign_id}`,
    context: "ui_show",
  });

  const { is_deleting, _delete } = useDelete({
    path: `/channels/${channel_id}/channel_campaigns/${channel_campaign_id}`,
    onSuccess: () => history.push(`/campaigns/channels/${channel_id}`),
  });

  if (is_loading) {
    return <PageLoader />;
  }

  if (is_error) {
    return <Error message={error} />;
  }

  return (
    <Main
      page={{
        name: channel_campaign?.name,
        icon: <ProductIcon />,
        breadcrumbs: [
          {
            name: "Kampanie reklamowe",
            path: `/campaigns/channels/${channel_id}`,
          },
          { name: channel_campaign?.name },
        ],
        buttons: (
          <Button
            type="delete"
            text="Usuń kampanię"
            disabled={is_deleting}
            onClick={() => setShowDeleteModal(true)}
          />
        ),
      }}
    >
      {show_delete_modal && (
        <ModalDelete
          handleDelete={_delete}
          handleClose={() => setShowDeleteModal(false)}
          name={`kampanię ${channel_campaign?.name}?`}
        />
      )}
      <CampaignStatsChart
        channel_id={channel_id}
        channel_campaign_id={channel_campaign_id}
      />
      <div className="dashboard-wrapper-flex">
        <div className="column-half">
          <BasicData
            channel_id={channel_id}
            channel_campaign={channel_campaign}
            refetch={refetch}
            initialValues={{
              name: channel_campaign?.name,
              status: channel_campaign?.status,
            }}
          />
        </div>
        <div className="column-half">
          <ChannelCampaignGroups
            channel_id={channel_id}
            channel_campaign_id={channel_campaign_id}
            data={channel_campaign?.channel_campaign_groups}
            refetch={refetch}
          />
        </div>
      </div>
    </Main>
  );
};

export default ChannelCampaignEdit;
